import name from './name'

const selectSliceData = state => state[name]

export const selectAiSkillsPracticeModules = state => selectSliceData(state).modules
